import React from 'react';

interface FilterHeaderProps {
  title: string;
  children?: React.ReactNode;
}

export const FilterHeader: React.FC<FilterHeaderProps> = ({
  title,
  children,
}) => {
  return (
    <div className="flex items-center justify-between p-4">
      <span className="text-base font-medium">{title}</span>
      {children}
    </div>
  );
};
